import { FEATURE_FLAGS } from '@Constants/featureFlagConstants';
import { type ApiRequisition } from '@Model';
import { Badge, useTranslate } from '@synqo/frontend-component-library';
import { actionChip, requisitionActionOf } from '@utils/requisitionAction';

interface RequisitionActionChipProps {
    requisition: Pick<ApiRequisition, 'container_actions'>;
}

/**
 * The one chip that says what an order is about, in the wizard's summary and in the two portal
 * lists alike. A second implementation would drift the moment a wording or a colour changes.
 *
 * It only appears where containers exist at all: with the flag off every order is loose material,
 * and a column of identical chips says nothing.
 */
// @ai-generated 2026-09-11T11:42:54+00:00 by matthias.gessinger@synqony.com using Claude Opus 5
export function RequisitionActionChip({ requisition }: RequisitionActionChipProps) {
    const i18n = useTranslate('');

    if (!FEATURE_FLAGS.CONTAINER_SERVICE) {
        return null;
    }

    const chip = actionChip(requisitionActionOf(requisition));

    return (
        <Badge variant={chip.variant} size="xxs">
            {i18n(chip.label)}
        </Badge>
    );
}
